// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'set';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M2.88 5.184a2.304 2.304 0 1 0 0-4.608 2.304 2.304 0 0 0 0 4.608zm12.24 12.24a2.304 2.304 0 1 0 0-4.608 2.304 2.304 0 0 0 0 4.608z' />
    <path d='M5.184 2.88H8.64c.432 0 .72.36.72.72v10.8c0 .432.36.792.792.792h2.664' />
  </g>
);

export const viewBox = '0 0 18 18';
